import TableWithSearch from '@/components/TableWithSearch'
import { useGetData } from '@/hooks/useGetData'
import { questionsConfig } from '@/utils/tablesData';
import React, { useState } from 'react'
import { DashboardLayout } from './Dashboard';
import { useLocation, useNavigate } from 'react-router';
import { Button } from '@/components/ui/button';
import { splitIcdCode } from '@/utils/helpers';
import { PlusIcon } from 'lucide-react';

const QuestionConfigGet = () => {
 
    const [question,setQuestion] = useState([]);
    // const {} = useGetData("/icd-q÷uestionnaire")
    console.log(question)
    const nav= useNavigate();
  return (
    <DashboardLayout activePage='/config' rightcomponent={<Button onClick={()=> nav("/config/add")}><PlusIcon /> Template</Button>}>

 <TableWithSearch
 clickRow={()=> {}}
 isColumnSelection
 columnPreferenceKey="icd-questionnaire-templates"
 apiDataKey="templates"
 columnHeaders={questionsConfig}
 data={question || []}
 viewData = {question.map((ques : any)=> ({...ques, icdCodes : ques.icdCodes.map((icd : any) => splitIcdCode(icd)?.[0])}) )}
 setData={setQuestion}
 fetchCondition={ true}
 isIncludeSearch
 searchPlaceholder="Search Template name or ICD code..."
 filters={[]}
 filtersOptions={[]}
 setFilters={()=> {}}
 heading=""
 isActionColumn
 handleAction={(data)=>  {nav(`/config/add/${data?._id}`,{state : {data}} )}}
 params={{}}
 url="/icd-questionnaire"
 
 key={"questionnaire"}
 
 
 />
 </DashboardLayout>
  )
}

export default QuestionConfigGet